import React, { Component } from 'react';
import CanalizadosComponent from './Components/CanalizadosComponent';
import PaymentsComponent from './Components/PaymentsComponent';
import TransportsComponent from './Components/TransportsComponent';
import ResumeTrComponent from './Components/ResumeTrComponent';
import AdminDeliveryComponent from './Components/AdminDeliveryComponent';
import AuthorizationsComponent from './Components/AuthorizationsComponent';
import ReabsResumeComponent from './Components/ReabsResumeComponent';
import CutTransferComponent from './Components/CutTransferComponent';
// esto es un intento de factory


class FactoryActions extends Component {

    getBody = () => {
        const { props } = this.props
        const { view } = props
        let body = <></>
        switch (view) {
            case 'canalizadoTanque':
                body = <CanalizadosComponent {...this.props} />
                break;
            case 'AccountsReceivable':
                body = <PaymentsComponent {...this.props} />
                break;
            case 'transports':
                body = <TransportsComponent {...this.props} />
                break;
            case 'resumeTr':
                body = <ResumeTrComponent {...this.props} />
                break;
            case 'adminDeliveries20':
                body = <AdminDeliveryComponent {...this.props} />
                break;
            case 'invoiceAuthorization':
                body = <AuthorizationsComponent {...this.props} />
                break;
            case 'reabsResume':
                body = <ReabsResumeComponent {...this.props} />
                break;
            case 'cutTransfers':
                body = <CutTransferComponent {...this.props} />
                break;
            default:
                body = <></>
                break;
        }
        return body

    }
    render() {
        return (
            this.getBody()
        );
    }
}

export default FactoryActions;
